import type { CapabilityName, EditorCapabilities } from "../editor/types";
import { getCapabilityNames } from "../editor/types";
import FullPreset from "./full/full";
import { getFullMenu } from "./full/fullMenu";
import type { GetPresetMenu } from "./menuTypes";
import MinimalPreset from "./minimal/minimal";
import { getMinimalMenu } from "./minimal/minimalMenu";
import SimplePreset from "./simple/simple";
import { getSimpleMenu } from "./simple/simpleMenu";

export type PresetDefinition = {
  capabilities: EditorCapabilities;
  /** Capability keys enabled by this preset (for custom filtering). */
  extensionNames: CapabilityName[];
  getMenu: GetPresetMenu;
};

export const presets: Record<
  "minimal" | "simple" | "full" | "custom",
  PresetDefinition
> = {
  minimal: {
    capabilities: MinimalPreset,
    extensionNames: getCapabilityNames(MinimalPreset),
    getMenu: getMinimalMenu,
  },
  simple: {
    capabilities: SimplePreset,
    extensionNames: getCapabilityNames(SimplePreset),
    getMenu: getSimpleMenu,
  },
  full: {
    capabilities: FullPreset,
    extensionNames: getCapabilityNames(FullPreset),
    getMenu: getFullMenu,
  },
  // A custom preset includes all options from the full preset but is tweaked by the consumer
  // Ref: customPresetExtensions and customPresetMenu props in the RichText component
  custom: {
    capabilities: FullPreset,
    extensionNames: getCapabilityNames(FullPreset),
    getMenu: getFullMenu,
  },
};
